import { Timeline } from 'antd';
import { timelineItem } from './view';
import React from 'react';

export const TimelineComponent = ({ timelineList, ...prop }) => {
  return <Timeline {...prop}>{timelineList?.map(timelineItem)}</Timeline>;
};
